import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const variantConfig = {
    success: {
        classes: 'bg-success-tint text-success-fg',
        borderClass: 'border-success/35',
        icon: '\u2713', // checkmark
    },
    error: {
        classes: 'bg-danger-tint text-danger-fg',
        borderClass: 'border-danger/35',
        icon: '\u2717', // X mark
    },
    warning: {
        classes: 'bg-warning-tint text-warning-fg',
        borderClass: 'border-warning/35',
        icon: '\u26A0', // warning
    },
    info: {
        classes: 'bg-info-tint text-info-fg',
        borderClass: 'border-info/35',
        icon: '\u2139', // info
    },
};
/**
 * Single toast notification item.
 */
export const Toast = ({ toast, onDismiss }) => {
    const config = variantConfig[toast.variant];
    return (_jsxs("div", { role: "status", "aria-live": "polite", "data-testid": `toast-${toast.variant}`, className: `flex items-center gap-2.5 rounded-md glass-surface px-3.5 py-2.5 text-sm font-medium shadow-dropdown max-w-[400px] w-full animate-[sam-toast-slide-in_200ms_ease-out] ${config.classes} ${config.borderClass}`, children: [_jsx("span", { className: "shrink-0 text-base", children: config.icon }), _jsx("span", { className: "flex-1 leading-[1.4]", children: toast.message }), _jsx("button", { onClick: () => onDismiss(toast.id), "aria-label": "Dismiss notification", className: "shrink-0 cursor-pointer border-none bg-transparent px-1 py-0.5 text-base leading-none opacity-70", children: '\u00D7' })] }));
};
/**
 * Absolutely-positioned container that renders toasts stacked at the top-right.
 * Keyframes defined in packages/ui/src/styles.css (sam-toast-slide-in).
 */
export const ToastContainer = ({ toasts, onDismiss }) => {
    if (toasts.length === 0)
        return null;
    return (_jsx("div", { className: "fixed top-4 right-4 z-toast flex flex-col gap-2 pointer-events-none", "aria-label": "Notifications", children: toasts.map((toast) => (_jsx("div", { className: "pointer-events-auto", children: _jsx(Toast, { toast: toast, onDismiss: onDismiss }) }, toast.id))) }));
};
//# sourceMappingURL=Toast.js.map